import { yotyDesigns } from './yotyDesigns';
import catalogue from './yotyCatalogue.json';
export const yotyCatalogue = catalogue;
export const ay2526Cover = '/yoty/oct20/cover-ay2526.png';
export const ay2526Description = "Missed out on last year's designs? Fret not, they're back! Here's your chance to grab the designs you missed out on! Check out our bundle deals for more savings!";
export const getYotyProduct = name => yotyCatalogue.find(item => item.name === name);
export const getProductDesigns = (name, type) => {
  const entry = getYotyProduct(name);
  return (yotyDesigns[type] || []).filter(design =>
    entry?.items.length > 1 || (design.collection || 'current') === entry?.collection
  );
};
export const getYotyImages = name => {
  const entry = getYotyProduct(name);
  return [...new Set([
    ...(entry?.cover ? [entry.cover] : []),
    ...(entry?.items || []).flatMap(type => getProductDesigns(name, type).flatMap(design => design.images)),
  ])];
};
export const withYotyImages = product => {
  const images = getYotyImages(product.name);
  return images.length ? { ...product, description: getYotyProduct(product.name).description, image: images[0], images } : product;
};
